/**
 *
 */
(() => {
  // job contact form - file upload
  const initUpload = () => {
    let fileUploadIncrement = 0;
    const fileUpload = (file) => {
      const formData = new FormData();
      formData.append('file', file);

      $.ajax({
        method: 'post',
        url: '/ajax/upload-file',
        data: formData,
        processData: false,
        contentType: false,
      }).then((response) => {
        if (response.status === 'success') {
          const { filepath } = response.data;

          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = (function () {
            return function () {
              document.querySelectorAll('.hero-form .file-list').forEach((filelist) => {
                fileUploadIncrement += 1;
                filelist.insertAdjacentHTML('beforeend', /* html */ `
                  <div class="file-wrap">
                    <label for="auditUpload${fileUploadIncrement}">${file.name}</label>
                    <input class="file-path" name="${file.name}-${fileUploadIncrement}" type="hidden" class="form-control" id="auditUpload${fileUploadIncrement}" value="${filepath}">
                    <i id="fileDelete-${fileUploadIncrement}" class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                `);

                const fileWrap = filelist.querySelector('.file-wrap');
                if (fileWrap) {
                  filelist.querySelector('.files-title.hide')?.classList.remove('hide');
                }
              });
              document.querySelectorAll('.file-drop .nButton + span').forEach((span) => {
                span.innerHTML = file.name;
              });
              document.getElementById(`fileDelete-${fileUploadIncrement}`).addEventListener('click', (item) => {
                const fileWrapper = item.target.closest('.file-list');
                item.target.closest('.file-wrap').remove();

                if (!fileWrapper.querySelector('.file-wrap')) {
                  fileWrapper.querySelector('.files-title').classList.add('hide');
                }
              });
            };
          }());
        }
      });
    };

    const clickFileUpload = (e) => {
      const form = e.target.closest('form');
      const query = form.querySelectorAll('.file-upload-button');
      query.forEach((input) => {
        input.click();
      });
    };

    const fileUploadChange = (e) => {
      if (e.target.files) {
        fileUpload(e.target.files[0]);
      }
    };

    const dropHandler = (e) => {
      e.preventDefault();

      if (e.dataTransfer.files) {
        fileUpload(e.dataTransfer.files[0]);
      }
    };

    const dragOverHandler = (e) => {
      e.preventDefault();
    };

    const drop = document.querySelectorAll('.file-drop');

    if (drop) {
      drop.forEach((item) => {
        item.addEventListener('drop', dropHandler.bind(this));
        item.addEventListener('dragover', dragOverHandler.bind(this));
        item.querySelector('.nButton')?.addEventListener('click', clickFileUpload.bind(this));
      });
    }

    if (document.querySelector('.file-upload-button')) {
      document.querySelectorAll('.file-upload-button').forEach((input) => {
        input.addEventListener('change', fileUploadChange.bind(this));
      });
    }
  };

  /**
 * Main Contact Form init fn
 */
  const buildForm = () => {
    const heroForm = document.querySelector('.hero-form');
    if (!heroForm) return;

    document.querySelectorAll('.contact-form-partial').forEach((formPart) => {
      if (formPart.closest('.hero-form')) return;

      const partName = formPart.getAttribute('data-name') || '';
      const partText = formPart.getAttribute('data-text') || '';

      if (heroForm.querySelector(`option[value="${partName}"]`)) return;

      heroForm.querySelector('#select-form').insertAdjacentHTML('beforeend', /* html */ `<option value="${partName}">${partText}</option>`);
    });

    const formSelect = document.getElementById('select-form');

    formSelect.addEventListener('change', (e) => {
    // This function will be called whenever the select option is changed
      const selectedOption = e.target.value;
      // Do something with the selected option
      const formPartHTML = document.querySelector(`.contact-form-partial[data-name="${selectedOption}"]`);
      if (!formPartHTML) return;

      heroForm.querySelector('.contact-form-partial-wrapper').innerHTML = '';
      heroForm.querySelector('.contact-form-partial-wrapper').append(formPartHTML.cloneNode(true));

      const drop = heroForm.querySelectorAll('.file-drop');

      if (drop) {
        initUpload();
      }
    });
  };

  /**
 * Init
 */
  (() => {
    const heroForm = document.querySelector('.hero-form');
    if (!heroForm) return;

    buildForm();

    // check url params to preselect form
    const params = new URLSearchParams(window.location.search);

    // Check if a parameter exists
    if (params.has('form')) {
      // Get the value of the parameter
      const paramValue = params.get('form');
      const formPartHTML = document.querySelector(`.contact-form-partial[data-name="${paramValue}"]`);
      if (!formPartHTML) return;

      heroForm.querySelector('#select-form').value = paramValue;
      heroForm.querySelector('.contact-form-partial-wrapper').innerHTML = '';
      heroForm.querySelector('.contact-form-partial-wrapper').append(formPartHTML.cloneNode(true));

      const drop = heroForm.querySelectorAll('.file-drop');

      if (drop) {
        initUpload();
      }
    }
  })();
})();
